(() => {
  const STORAGE_KEY = 'kham_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function escapeHTML(value = '') {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document
      .querySelectorAll('[data-kham-wishlist-count]')
      .forEach((badge) => {
        badge.textContent = count;

        if (count > 0) {
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
  }

  function updateButtons() {
    const wishlist = getWishlist();

    document
      .querySelectorAll('.kham-wishlist-save')
      .forEach((button) => {
        const productId = button.dataset.productId;

        const saved = wishlist.some(
          (item) => String(item.id) === String(productId)
        );

        button.setAttribute(
          'aria-pressed',
          saved ? 'true' : 'false'
        );

        const heart = button.querySelector(
          '.kham-wishlist-save__heart'
        );

        const text = button.querySelector(
          '.kham-wishlist-save__text'
        );

        if (heart) {
          heart.textContent = saved ? '♥' : '♡';
        }

        if (text) {
          text.textContent = saved
            ? 'SAVED TO WISHLIST'
            : 'SAVE TO WISHLIST';
        }
      });
  }

  function renderDrawer() {
    const drawer = document.querySelector(
      '#kham-wishlist-drawer'
    );

    if (!drawer) return;

    const list = drawer.querySelector(
      '[data-kham-wishlist-list]'
    );

    const empty = drawer.querySelector(
      '[data-kham-wishlist-empty]'
    );

    if (!list || !empty) return;

    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      list.innerHTML = '';
      list.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    list.hidden = false;

    list.innerHTML = wishlist
      .map(
        (item) => `
          <article class="kham-wishlist-item">

            <a
              href="${escapeHTML(item.url)}"
              class="kham-wishlist-item__image"
              aria-label="${escapeHTML(item.title)}"
            >
              ${
                item.image
                  ? `
                    <img
                      src="${escapeHTML(item.image)}"
                      alt="${escapeHTML(item.title)}"
                      loading="lazy"
                    >
                  `
                  : ''
              }
            </a>

            <div class="kham-wishlist-item__content">

              <a
                href="${escapeHTML(item.url)}"
                class="kham-wishlist-item__title"
              >
                ${escapeHTML(item.title)}
              </a>

              <div class="kham-wishlist-item__price">
                ${escapeHTML(item.price)}
              </div>

              <button
                type="button"
                class="kham-wishlist-item__remove"
                data-remove-wishlist="${escapeHTML(
                  String(item.id)
                )}"
              >
                REMOVE
              </button>

            </div>

          </article>
        `
      )
      .join('');
  }

  function toggleProduct(button) {
    const productId = button.dataset.productId;

    if (!productId) return;

    let wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(
      (item) => String(item.id) === String(productId)
    );

    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.push({
        id: productId,
        handle: button.dataset.productHandle || '',
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }

    saveWishlist(wishlist);

    updateButtons();
    renderDrawer();
    updateWishlistCount();
  }

  function removeProduct(productId) {
    const wishlist = getWishlist().filter(
      (item) => String(item.id) !== String(productId)
    );

    saveWishlist(wishlist);

    updateButtons();
    renderDrawer();
    updateWishlistCount();
  }

  function initWishlist() {
    updateButtons();
    renderDrawer();
    updateWishlistCount();
  }

  document.addEventListener('click', (event) => {
    const saveButton = event.target.closest(
      '.kham-wishlist-save'
    );

    if (saveButton) {
      event.preventDefault();
      toggleProduct(saveButton);
      return;
    }

    const removeButton = event.target.closest(
      '[data-remove-wishlist]'
    );

    if (removeButton) {
      event.preventDefault();

      removeProduct(
        removeButton.dataset.removeWishlist
      );
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      initWishlist();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initWishlist
    );
  } else {
    initWishlist();
  }

  document.addEventListener(
    'shopify:section:load',
    initWishlist
  );
})();